{
	"objectMode": false,
	"encoding": null,
	"sep": "\n",
	"copy": true,
	"siter": 1e308
}
